import { ConfirmationModalData } from 'src/app/shared/modals/confirmation-modal/modal-data.models';

// Backing out of a form is not destructive, so the confirm button uses the default
// (solid mint) rather than the red `isWarning` treatment reserved for errors.
export const RequestExitConfirmationData: ConfirmationModalData = {
  message: 'Are you sure you want to exit out of this request?',
  confirmationButtonText: 'Exit',
};